import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../_layout/DashboardLayout/dashboard.layout';
import { PageTitle } from '../../_core/_ui/typography.component';
import { AssessmentStageBuilderGraphQL } from '../../AssessmentStage/AssessmentStageBuilder/assessment-stage-builder.graphql';
import { PageHeaderRow, SectionWrapper } from '../../_core/_ui/structure.components';

export const ConfigureSchedulePage = () => (
  <DashboardLayout hideSidebar>
    <Grid container>
      <PageHeaderRow><PageTitle>Configure Schedule</PageTitle></PageHeaderRow>
    </Grid>
    <SectionWrapper>
      <AssessmentStageBuilderGraphQL />
    </SectionWrapper>
  </DashboardLayout>
);
